// src/components/editor/useEditorWithDragDrop.js
import { useEffect } from 'react';
import { useEditor } from '@tiptap/react';

export default function useEditorWithDragDrop(extensions, initialContent = '', options = {}) {
  const { onImageUpload, editable = true } = options;

  const editor = useEditor({
    extensions,
    content: initialContent,
    editable,
  });

  useEffect(() => {
    if (!editor || editor.isDestroyed || !editor.view?.dom) return;

    const insertImage = (src) => {
      editor.chain().focus().insertContent({
        type: 'resizableImage',
        attrs: { src, width: 'auto', height: 'auto', alt: '' },
      }).run();
    };

    const handleDrop = async (event) => {
      event.preventDefault();
      const file = event.dataTransfer.files?.[0];
      if (!file || !file.type.startsWith('image/')) return;

      if (onImageUpload) {
        try {
          const url = await onImageUpload(file);
          insertImage(url);
        } catch (err) {
          console.error('에디터 이미지 업로드 실패:', err);
        }
        return;
      }

      const reader = new FileReader();
      reader.onload = () => insertImage(reader.result);
      reader.readAsDataURL(file);
    };

    const dom = editor.view.dom;
    dom.addEventListener('drop', handleDrop);
    dom.addEventListener('dragover', (e) => e.preventDefault());

    return () => {
      dom.removeEventListener('drop', handleDrop);
      dom.removeEventListener('dragover', (e) => e.preventDefault());
    };
  }, [editor, onImageUpload]);

  return editor;
}